import {
  FacetedFilterFacetItemType,
  FacetedFilterContainerItemType,
  FacetedFilterUtilContainerItemType,
  FacetedFilterOperatorType,
  FacetedFilterItemValueType,
} from '../types/constants';

export class TypeCheck {
  public static isFacet(type: string): boolean {
    return Object.values(FacetedFilterFacetItemType).includes(type as FacetedFilterFacetItemType);
  }

  public static isHierarchyFacet(type: string): boolean {
    return type === FacetedFilterFacetItemType.HierarchyFacet;
  }

  public static isContainer(type: string): boolean {
    return Object.values(FacetedFilterContainerItemType).includes(type as FacetedFilterContainerItemType);
  }

  public static isUtilityContainer(type: string): boolean {
    if (
      type === FacetedFilterUtilContainerItemType.DateRangePicker ||
      type.includes(FacetedFilterUtilContainerItemType.Operator)
    )
      return true;

    return false;
  }

  public static isOperatorContainer(type: string): boolean {
    return type.includes(FacetedFilterUtilContainerItemType.Operator);
  }

  public static isDateRangePickerContainer(type: string): boolean {
    return type === FacetedFilterUtilContainerItemType.DateRangePicker;
  }

  public static isHierarchyContainer(type: string): boolean {
    return type === FacetedFilterContainerItemType.HierarchyContainer;
  }

  public static isReplayableContainer(type: string): boolean {
    return this.isContainer(type) || this.isDateRangePickerContainer(type);
  }

  public static hasOperatorType(type: string): boolean {
    return Object.values(FacetedFilterOperatorType).includes(type as FacetedFilterOperatorType);
  }

  public static isDateRangeValueType(valueType: string): boolean {
    return valueType === FacetedFilterItemValueType.DateRangeValue;
  }

  public static isBooleanValueType(valueType: string): boolean {
    return valueType === FacetedFilterItemValueType.BooleanValue;
  }
}
